window.theme = window.theme || {};
window.theme = window.theme || {};
theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};
jQuery(document).on("click", ".closeBtn", function(){
  jQuery(".site-header__cart").trigger("click");
});
/*jQuery(".closeBtn").on("click", function () {
  jQuery(".site-header__cart").trigger("click");
});*/
theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var $container = $(container);
        var id = $container.attr("data-section-id");
        var type = $container.attr("data-section-type");
        constructor = constructor || this.constructors[type];
        if (_.isUndefined(constructor)) {
            return;
        }
        var instance = _.assignIn(new constructor(container), { id: id, type: type, container: container });
        this.instances.push(instance);
    },
    _onSectionLoad: function (evt) {
        var container = $("[data-section-id]", evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },
    _onSectionUnload: function (evt) {
        this.instances = _.filter(this.instances, function (instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;
            if (isEventInstance) {
                if (_.isFunction(instance.onUnload)) {
                    instance.onUnload(evt);
                }
            }
            return !isEventInstance;
        });
    },
    _onSelect: function (evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
            instance.onSelect(evt);
        }
    },
    _onDeselect: function (evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
            instance.onDeselect(evt);
        }
    },
    _onBlockSelect: function (evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
            instance.onBlockSelect(evt);
        }
    },
    _onBlockDeselect: function (evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
            instance.onBlockDeselect(evt);
        }
    },
    register: function (type, constructor) {
        this.constructors[type] = constructor;
        $("[data-section-type=" + type + "]").each(
            function (index, container) {
                this._createInstance(container, constructor);
            }.bind(this)
        );
    },
});
window.slate = window.slate || {};
slate.rte = {
    wrapTable: function () {
        $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
    },
    iframeReset: function () {
        var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
        var $iframeReset = $iframeVideo.add(".rte iframe#admin_bar_iframe");
        $iframeVideo.each(function () {
            $(this).wrap('<div class="video-wrapper"></div>');
        });
        $iframeReset.each(function () {
            this.src = this.src;
        });
    },
};
window.slate = window.slate || {};
slate.a11y = {
    pageLinkFocus: function ($element) {
        var focusClass = "js-focus-hidden";
        $element.first().attr("tabIndex", "-1").focus().addClass(focusClass).one("blur", callback);
        function callback() {
            $element.first().removeClass(focusClass).removeAttr("tabindex");
        }
    },
    focusHash: function () {
        var hash = window.location.hash;
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },
    bindInPageLinks: function () {
        $("a[href*=#]").on(
            "click",
            function (evt) {
                this.pageLinkFocus($(evt.currentTarget.hash));
            }.bind(this)
        );
    },
    trapFocus: function (options) {
        var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }
        options.$container.attr("tabindex", "-1");
        options.$elementToFocus.focus();
        $(document).off("focusin");
        $(document).on(eventName, function (evt) {
            if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                options.$container.focus();
            }
        });
    },
    removeTrapFocus: function (options) {
        var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
        if (options.$container && options.$container.length) {
            options.$container.removeAttr("tabindex");
        }
        $(document).off(eventName);
    },
};
theme.Images = (function () {
    function preload(images, size) {
        if (typeof images === "string") {
            images = [images];
        }
        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }
    function loadImage(path) {
        new Image().src = path;
    }
    function switchImage(image, element, callback) {
        var size = this.imageSize(element.src);
        var imageUrl = this.getSizedImageUrl(image.src, size);
        if (callback) {
            callback(imageUrl, image, element);
        } else {
            element.src = imageUrl;
        }
    }
    function imageSize(src) {
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
        if (match !== null) {
            return match[1];
        } else {
            return null;
        }
    }
    function getSizedImageUrl(src, size) {
        if (size == null) {
            return src;
        }
        if (size === "master") {
            return this.removeProtocol(src);
        }
        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (match != null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return this.removeProtocol(prefix[0] + "_" + size + suffix);
        }
        return null;
    }
    function removeProtocol(path) {
        return path.replace(/http(s)?:/, "");
    }
    return { preload: preload, loadImage: loadImage, switchImage: switchImage, imageSize: imageSize, getSizedImageUrl: getSizedImageUrl, removeProtocol: removeProtocol };
})();
theme.Currency = (function () {
    var moneyFormat = "${{amount}}";
    function formatMoney(cents, format) {
        if (typeof cents === "string") {
            cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = "undefined" == typeof precision ? 2 : precision;
            thousands = thousands || ",";
            decimal = decimal || ".";
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split(".");
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
            var centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
        }
        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                value = formatWithDelimiters(cents, 0, " ");
                break;
        }
        return formatString.replace(placeholderRegex, value);
    }
    return { formatMoney: formatMoney };
})();
slate.Variants = (function () {
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();
        $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
    }
    Variants.prototype = _.assignIn({}, Variants.prototype, {
        _getCurrentOptions: function () {
            //console.log('variant', $(this.singleOptionSelector, this.$container));
            var currentOptions = _.map($(this.singleOptionSelector, this.$container), function (element) {
              if(element.classList.contains("active_select_box")){
                var $element = $(element);
                var type = $element.attr("type");
                var currentOption = {};
                if (type === "radio" || type === "checkbox") {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data("index");
                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data("index");
                    return currentOption;
                }
              }
            });
            currentOptions = _.compact(currentOptions);
            return currentOptions;
        },
        _getVariantFromOptions: function () {
            var selectedValues = this._getCurrentOptions();
            if($(".active_pro").length > 0){
              this.products = JSON.parse(document.querySelector(".active_pro").innerHTML);
              var variants = this.products.variants;
            }else{
              var variants = this.product.variants;
            }
            
            var found = _.find(variants, function (variant) {
                return selectedValues.every(function (values) {
                    return _.isEqual(variant[values.index], values.value);
                });
            });
            return found;
        },
        _onSelectChange: function () {
            var variant = this._getVariantFromOptions();
            this.$container.trigger({ type: "variantChange", variant: variant });
            if (!variant) {
                return;
            }
          var mainClass = this.$container;
            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this._updateSKU(variant);
            this._updateAddToCart(variant);
            this.currentVariant = variant;
            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
            this._updateSticky(variant, mainClass);
        },
        _updateImages: function (variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};
            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }
            this.$container.trigger({ type: "variantImageChange", variant: variant });
        },
        _updatePrice: function (variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }
            this.$container.trigger({ type: "variantPriceChange", variant: variant });
        },
        _updateSKU: function (variant) {
            if (variant.sku === this.currentVariant.sku) {
                return;
            }
            this.$container.trigger({ type: "variantSKUChange", variant: variant });
        },
        _updateAddToCart(variant){
          if(variant.title == 'Custom Made: Your specific measurements'){
            const clkEvnt = new Event("click", {bubbles: true});
            document.querySelector("#AddToCart-product-template").classList.remove("product-form__cart-submit");
            document.querySelector("#AddToCart-product-template").classList.add("add_to_cart_btn");
            document.querySelector(".size-popup-btn").dispatchEvent(clkEvnt);
            //setTimeout(function(){ document.querySelector("#AddToCart-product-template").dispatchEvent(clkEvnt); }, 500);
          }else{
            document.querySelector("#AddToCart-product-template").classList.add("product-form__cart-submit");
            document.querySelector("#AddToCart-product-template").classList.remove("add_to_cart_btn");
          }
        },
        _updateHistoryState: function (variant) {
            if (!history.replaceState || !variant) {
                return;
            }
          /*var element = document.getElementById("notify_me_btn");
          
          if(typeof(element) != 'undefined' && element != null){
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
            window.history.replaceState({ path: newurl }, "", newurl);
          }else{
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
            window.history.replaceState({ path: newurl }, "", newurl);
          }*/
          
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
            window.history.replaceState({ path: newurl }, "", newurl);
        },
        _updateMasterSelect: function (variant) {
            $(this.originalSelectorId, this.$container).val(variant.id);
        },
        _updateSticky: function (variant, mainClass) {
          var url = mainClass.find(".product-single").data("url")+"?variant="+variant.id;
          fetch(url)
          .then(data => data.text())
          .then(fData => {
            var fHtml = new DOMParser().parseFromString(fData, 'text/html');
            var dest = document.querySelector(".fix_addtocart"),
                src = fHtml.querySelector(".fix_addtocart");
            if(dest && src){
              dest.innerHTML = src.innerHTML;
            }
          })
        },
    });
    return Variants;
})();
theme.Drawers = (function () {
    function Drawer(id, position, options) {
        var defaults = { close: ".js-drawer-close", open: ".js-drawer-open-" + position, openClass: "js-drawer-open", dirOpenClass: "js-drawer-open-" + position };
        this.nodes = { $parent: $("html").add("body"), $page: $("#PageContainer, #shopify-section-header") };
        this.config = $.extend(defaults, options);
        this.position = position;
        this.$drawer = $("#" + id);
        if (!this.$drawer.length) {
            return false;
        }
        this.drawerIsOpen = false;
        this.init();
    }
    Drawer.prototype.init = function () {
        $(this.config.open).on("click", $.proxy(this.open, this));
        this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
    };
    Drawer.prototype.open = function (evt) {
        var externalCall = false;
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            this.$activeSource = $(evt.currentTarget);
        }
        if (this.drawerIsOpen && !externalCall) {
            return this.close();
        }
        this.$drawer.prepareTransition();
        this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass);
        this.drawerIsOpen = true;
        slate.a11y.trapFocus({ $container: this.$drawer, namespace: "drawer_focus" });
        if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === "function") {
            if (!externalCall) {
                this.config.onDrawerOpen();
            }
        }
        if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
            this.$activeSource.attr("aria-expanded", "true");
        }
        this.bindEvents();
        return this;
    };
    Drawer.prototype.close = function () {
      
        if (!this.drawerIsOpen) {
            return;
        }
        $(document.activeElement).trigger("blur");
        this.$drawer.prepareTransition();
        this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass);
        this.drawerIsOpen = false;
        slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" });
        this.unbindEvents();
    };
    Drawer.prototype.bindEvents = function () {
        this.nodes.$parent.on(
            "keyup.drawer",
            $.proxy(function (evt) {
                if (evt.keyCode === 27) {
                    this.close();
                    return false;
                } else {
                    return true;
                }
            }, this)
        );
        this.nodes.$page.on("touchmove.drawer", function () {
            return false;
        });
        this.nodes.$page.on(
            "click.drawer",
            $.proxy(function () {
                this.close();
                return false;
            }, this)
        );
    };
    Drawer.prototype.unbindEvents = function () {
        this.nodes.$page.off(".drawer");
        this.nodes.$parent.off(".drawer");
    };
    return Drawer;
})();
window.theme = window.theme || {};
theme.Header = (function () {
    var selectors = {
        body: "body",
        navigation: "#AccessibleNav",
        siteNavHasDropdown: ".site-nav--has-dropdown",
        siteNavChildLinks: ".site-nav__child-link",
        siteNavActiveDropdown: ".site-nav--active-dropdown",
        siteNavLinkMain: ".site-nav__link--main",
        siteNavChildLink: ".site-nav__link--last",
    };
    var config = { activeClass: "site-nav--active-dropdown", childLinkClass: "site-nav__child-link" };
    var cache = {};
    function init() {
        cacheSelectors();
        cache.$parents.on("click.siteNav", function (evt) {
            var $el = $(this);
            if (!$el.hasClass(config.activeClass)) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
            }
            showDropdown($el);
        });
        $(selectors.siteNavChildLink).on("focusout.siteNav", function () {
            setTimeout(function () {
                if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
                    return;
                }
                hideDropdown(cache.$activeDropdown);
            });
        });
        cache.$topLevel.on("focus.siteNav", function () {
            if (cache.$activeDropdown.length) {
                hideDropdown(cache.$activeDropdown);
            }
        });
        cache.$subMenuLinks.on("click.siteNav", function (evt) {
            evt.stopImmediatePropagation();
        });
    }
    function cacheSelectors() {
        cache = {
            $nav: $(selectors.navigation),
            $topLevel: $(selectors.siteNavLinkMain),
            $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
            $subMenuLinks: $(selectors.siteNavChildLinks),
            $activeDropdown: $(selectors.siteNavActiveDropdown),
        };
    }
    function showDropdown($el) {
        $el.addClass(config.activeClass);
        if (cache.$activeDropdown.length) {
            hideDropdown(cache.$activeDropdown);
        }
        cache.$activeDropdown = $el;
        $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "true");
        setTimeout(function () {
            $(window).on("keyup.siteNav", function (evt) {
                if (evt.keyCode === 27) {
                    hideDropdown($el);
                }
            });
            $(selectors.body).on("click.siteNav", function () {
                hideDropdown($el);
            });
        }, 250);
    }
    function hideDropdown($el) {
        $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "false");
        $el.removeClass(config.activeClass);
        cache.$activeDropdown = $(selectors.siteNavActiveDropdown);
        $(selectors.body).off("click.siteNav");
        $(window).off("keyup.siteNav");
    }
    function unload() {
        $(window).off(".siteNav");
        cache.$parents.off(".siteNav");
        cache.$subMenuLinks.off(".siteNav");
        cache.$topLevel.off(".siteNav");
        $(selectors.siteNavChildLink).off(".siteNav");
        $(selectors.body).off(".siteNav");
    }
    return { init: init, unload: unload };
})();
window.theme = window.theme || {};
theme.Search = (function () {
    var selectors = {
        search: ".search",
        searchSubmit: ".search__submit",
        searchInput: ".search__input",
        siteHeader: "#shopify-section-header .header-wrap",
        notification: ".notification-bar",
        siteHeaderSearchToggle: ".site-header__search-toggle",
        siteHeaderSearch: ".site-header__search",
        searchDrawer: ".search-bar",
        searchDrawerInput: ".search-bar__input",
        searchHeader: ".search-header",
        searchHeaderInput: ".search-header__input",
        searchHeaderSubmit: ".search-header__submit",
        mobileNavWrapper: ".mobile-nav-wrapper",
    };
    var classes = { focus: "search--focus", mobileNavIsOpen: "js-menu--is-open" };
    function init() {
        if (!$(selectors.siteHeader).length) {
            return;
        }
        initDrawer();
        searchSubmit();
        $(selectors.searchHeaderInput)
            .add(selectors.searchHeaderSubmit)
            .on("focus blur", function () {
                $(selectors.searchHeader).toggleClass(classes.focus);
            });
        $(selectors.siteHeaderSearchToggle).on("click", function () {
          if ($(".customer-links").is(":visible")) {
              $(".customer-links").slideUp();
          }
          if ($(".currencies").is(":visible")) {
              $(".currencies").slideUp();
          }
          var searchHeight = $(selectors.siteHeader).outerHeight();
          var searchOffset = $(selectors.siteHeader).height();
          if ($(".notification-bar").is(":visible")) {
              //searchOffset = searchOffset + $(".notification-bar").height();
          } else {
              searchOffset = $(selectors.siteHeader).height();
          }
          $(selectors.searchDrawer).css({ height: searchHeight + "px", top: searchOffset + "px" });
          $("#header-cart").hide();
          if($(this).parents("header").hasClass("apply_bg_color")){
            setTimeout(() => {$(this).parents("header").removeClass("apply_bg_color");}, 500);
          }else{
            $(this).parents("header").addClass("apply_bg_color");
          }
        });
        $("#searchBtn").on("click", function () {
            $(".search-bar__form").submit();
        });

        $('.search-bar__form').submit(function(event) {
          if(!event.target.querySelector("input[name='q']").value){
            event.preventDefault();
          }
        });
      
        var currentAjaxRequest = null;
        var searchForms = $('form.search-bar__form[role="search"]')
          .css("position", "relative")
          .each(function () {
            var this_obj = $(this);
            var input = $(this).find('input[name="q"]');
            var offSet = input.position().top + input.innerHeight();
            $('<ul class="search-results"></ul>').css({ position: "absolute", left: "0px", top: offSet }).appendTo($(this)).hide();
          
            input.attr("autocomplete", "off").bind("keyup change", function () {
              if($(this).parents("#SearchDrawer")){
                var term = $(this).val();
                var form = $(this).closest("form");
                var searchURL = "/search?type=product&q=" + term;
                var resultsList = form.find(".search-results");
                var resultCount = 0;

                if (term.length > 3) {
                  $(this).attr("data-old-term", term);

                  fetch(searchURL+"&view=json")
                  .then(response => response.json())
                  .then(data => {
                    resultsList.empty();
                    const products = data.products;
                    //input.blur(); 
                    var count = 0;
                    for (i=0; i<products.length; i++){
                      if(products[i]['id']){
                        count = count + 1;
                      }
                    }
                    
                    if (count == 0) {
                      this_obj.find(".search_title").length > 0 ? this_obj.find(".search_title").remove() : '';
                      resultsList.show();
                      resultsList.html("<p class='search_title'>No Suggestions</p>");
                    }else{
                      this_obj.find(".search_title").length > 0 ? this_obj.find(".search_title").remove() : '';
                      $("<p class='search_title'>Suggestions</p>").insertBefore(this_obj.find(".search-results"));
                      $.each(products, function (index, item) {
                        if(products[index]['id']){
                          if(resultCount < 5){
                            var link = $("<a></a>").attr("href", item.url);
                            link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
                            link.append('<span class="title">' + item.title + "</span>");
                            link.append('<span class="price">' + item.price + "</span>");
                            link.wrap("<li></li>");
                            resultsList.append(link.parent());
                            resultCount = resultCount + 1;
                          }
                        }
                      });
                      resultsList.fadeIn(200);
                    }
                  })
                  .catch(error => console.error('Error fetching products:', error));
                  /*$.ajax({
                    type: "POST",
                    url: searchURL + "&view=json",
                    dataType: 'html',
                    success: function(data){
                      resultsList.empty();
                      if($(data).find("li").length > 0){
                        this_obj.find(".search_title").length > 0 ? this_obj.find(".search_title").remove() : '';
                        $("<p class='search_title'>Suggestions</p>").insertBefore(this_obj.find(".search-results"));
                        resultsList.html($(data).html());
                        resultsList.fadeIn(200);
                      }else{
                        this_obj.find(".search_title").length > 0 ? this_obj.find(".search_title").remove() : '';
                        resultsList.html("<p class='search_title'>No Suggestions</p>");
                        resultsList.show();
                      }
                      input.blur(); 
                    }
                  });*/         
                }else {
                  this_obj.find(".search_title").length > 0 ? this_obj.find(".search_title").remove() : '';
                  resultsList.html('');
                  resultsList.hide();
                }
              }
            });
          });
        $("#PageContainer").bind("click", function () {
            $(".search-results").hide();
        });
    }
    function initDrawer() {
        $("#PageContainer").addClass("drawer-page-content");
        $(".js-drawer-open-top").attr("aria-controls", "SearchDrawer").attr("aria-expanded", "false");
        theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", { onDrawerOpen: searchDrawerFocus });
    }
    function searchDrawerFocus() {
        searchFocus($(selectors.searchDrawerInput));
    }
    function searchFocus($el) {
        $el.focus();
        $el[0].setSelectionRange(0, $el[0].value.length);
    }
    function searchSubmit() {
        $(selectors.searchSubmit).on("click", function (evt) {
            var $el = $(evt.target);
            var $input = $el.parents(selectors.search).find(selectors.searchInput);
            if ($input.val().length === 0) {
                evt.preventDefault();
                searchFocus($input);
            }
        });
    }
    return { init: init };
})();
(function () {
    var selectors = { backButton: ".return-link" };
    var $backButton = $(selectors.backButton);
    if (!document.referrer || !$backButton.length || !window.history.length) {
        return;
    }
    $backButton.one("click", function (evt) {
        evt.preventDefault();
        var referrerDomain = urlDomain(document.referrer);
        var shopDomain = urlDomain(window.location.href);
        if (shopDomain === referrerDomain) {
            history.back();
        }
        return false;
    });
    function urlDomain(url) {
        var anchor = document.createElement("a");
        anchor.ref = url;
        return anchor.hostname;
    }
})();
theme.Slideshow = (function () {
    this.$slideshow = null;
    var classes = {
        wrapper: "slideshow-wrapper",
        slideshow: "slideshow",
        currentSlide: "slick-current",
        video: "slideshow__video",
        videoBackground: "slideshow__video--background",
        closeVideoBtn: "slideshow__video-control--close",
        pauseButton: "slideshow__pause",
        isPaused: "is-paused",
    };
    function slideshow(el) {
        this.$slideshow = $(el);
        this.$wrapper = this.$slideshow.closest("." + classes.wrapper);
        this.$pause = this.$wrapper.find("." + classes.pauseButton);
        this.settings = { accessibility: true, arrows: true, dots: true, fade: true, rtl: theme.rtl, draggable: true, touchThreshold: 20, autoplay: this.$slideshow.data("autoplay"), autoplaySpeed: this.$slideshow.data("speed") };
        this.$slideshow.on("beforeChange", beforeChange.bind(this));
        this.$slideshow.on("init", slideshowA11y.bind(this));
        this.$slideshow.slick(this.settings);
        this.$pause.on("click", this.togglePause.bind(this));
    }
    function slideshowA11y(event, obj) {
        var $slider = obj.$slider;
        var $list = obj.$list;
        var $wrapper = this.$wrapper;
        var autoplay = this.settings.autoplay;
        $list.removeAttr("aria-live");
        $wrapper.on("focusin", function (evt) {
            if (!$wrapper.has(evt.target).length) {
                return;
            }
            $list.attr("aria-live", "polite");
            if (autoplay) {
                $slider.slick("slickPause");
            }
        });
        $wrapper.on("focusout", function (evt) {
            if (!$wrapper.has(evt.target).length) {
                return;
            }
            $list.removeAttr("aria-live");
            if (autoplay) {
                if ($(evt.target).hasClass(classes.closeVideoBtn)) {
                    return;
                }
                $slider.slick("slickPlay");
            }
        });
        if (obj.$dots) {
            obj.$dots.on("keydown", function (evt) {
                if (evt.which === 37) {
                    $slider.slick("slickPrev");
                }
                if (evt.which === 39) {
                    $slider.slick("slickNext");
                }
                if (evt.which === 37 || evt.which === 39) {
                    obj.$dots.find(".slick-active button").focus();
                }
            });
        }
    }
    function beforeChange(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find("." + classes.currentSlide);
        var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');
        if (isVideoInSlide($currentSlide)) {
            var $currentVideo = $currentSlide.find("." + classes.video);
            var currentVideoId = $currentVideo.attr("id");
            theme.SlideshowVideo.pauseVideo(currentVideoId);
            $currentVideo.attr("tabindex", "-1");
        }
        if (isVideoInSlide($nextSlide)) {
            var $video = $nextSlide.find("." + classes.video);
            var videoId = $video.attr("id");
            var isBackground = $video.hasClass(classes.videoBackground);
            if (isBackground) {
                theme.SlideshowVideo.playVideo(videoId);
            } else {
                $video.attr("tabindex", "0");
            }
        }
    }
    function isVideoInSlide($slide) {
        return $slide.find("." + classes.video).length;
    }
    slideshow.prototype.togglePause = function () {
        var slideshowSelector = getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
            this.$pause.removeClass(classes.isPaused);
            $(slideshowSelector).slick("slickPlay");
        } else {
            this.$pause.addClass(classes.isPaused);
            $(slideshowSelector).slick("slickPause");
        }
    };
    function getSlideshowId($el) {
        return "#Slideshow-" + $el.data("id");
    }
    return slideshow;
})();
function onYouTubeIframeAPIReady() {
    theme.SlideshowVideo.loadVideos();
}
theme.SlideshowVideo = (function () {
    var autoplayCheckComplete = false;
    var autoplayAvailable = false;
    var playOnClickChecked = false;
    var playOnClick = false;
    var youtubeLoaded = false;
    var videos = {};
    var videoPlayers = [];
    var videoOptions = {
        ratio: 16 / 9,
        playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, controls: 0, showinfo: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
        events: { onReady: onPlayerReady, onStateChange: onPlayerChange },
    };
    var classes = {
        playing: "video-is-playing",
        paused: "video-is-paused",
        loading: "video-is-loading",
        loaded: "video-is-loaded",
        slideshowWrapper: "slideshow-wrapper",
        slide: "slideshow__slide",
        slideBackgroundVideo: "slideshow__slide--background-video",
        slideDots: "slick-dots",
        videoChrome: "slideshow__video--chrome",
        videoBackground: "slideshow__video--background",
        playVideoBtn: "slideshow__video-control--play",
        closeVideoBtn: "slideshow__video-control--close",
        currentSlide: "slick-current",
        slickClone: "slick-cloned",
        supportsAutoplay: "autoplay",
        supportsNoAutoplay: "no-autoplay",
    };
    function init($video) {
        if (!$video.length) {
            return;
        }
        videos[$video.attr("id")] = {
            id: $video.attr("id"),
            videoId: $video.data("id"),
            type: $video.data("type"),
            status: $video.data("type") === "chrome" ? "closed" : "background",
            videoSelector: $video.attr("id"),
            $parentSlide: $video.closest("." + classes.slide),
            $parentSlideshowWrapper: $video.closest("." + classes.slideshowWrapper),
            controls: $video.data("type") === "background" ? 0 : 1,
            slideshow: $video.data("slideshow"),
        };
        if (!youtubeLoaded) {
            var tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    }
    function customPlayVideo(playerId) {
        if (!playOnClickChecked && !playOnClick) {
            return;
        }
        if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
            privatePlayVideo(playerId);
        }
    }
    function pauseVideo(playerId) {
        if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === "function") {
            videoPlayers[playerId].pauseVideo();
        }
    }
    function loadVideos() {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var args = $.extend({}, videoOptions, videos[key]);
                args.playerVars.controls = args.controls;
                videoPlayers[key] = new YT.Player(key, args);
            }
        }
        initEvents();
        youtubeLoaded = true;
    }
    function loadVideo(key) {
        if (!youtubeLoaded) {
            return;
        }
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
        initEvents();
    }
    function privatePlayVideo(id, clicked) {
        var videoData = videos[id];
        var player = videoPlayers[id];
        var $slide = videos[id].$parentSlide;
        if (playOnClick) {
            setAsPlaying(videoData);
        } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
            $slide.removeClass(classes.loading);
            setAsPlaying(videoData);
            player.playVideo();
            return;
        }
        if (!autoplayCheckComplete) {
            autoplayCheckFunction(player, $slide);
        }
    }
    function setAutoplaySupport(supported) {
        var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
        $(document.documentElement).addClass(supportClass);
        if (!supported) {
            playOnClick = true;
        }
        autoplayCheckComplete = true;
    }
    function autoplayCheckFunction(player, $slide) {
        player.playVideo();
        autoplayTest(player)
            .then(function () {
                setAutoplaySupport(true);
            })
            .fail(function () {
                setAutoplaySupport(false);
                player.stopVideo();
            })
            .always(function () {
                autoplayCheckComplete = true;
                $slide.removeClass(classes.loading);
            });
    }
    function autoplayTest(player) {
        var deferred = $.Deferred();
        var wait;
        var timeout;
        wait = setInterval(function () {
            if (player.getCurrentTime() <= 0) {
                return;
            }
            autoplayAvailable = true;
            clearInterval(wait);
            clearTimeout(timeout);
            deferred.resolve();
        }, 500);
        timeout = setTimeout(function () {
            clearInterval(wait);
            deferred.reject();
        }, 4000);
        return deferred;
    }
    function playOnClickCheck() {
        if (playOnClickChecked) {
            return;
        }
        if ($(window).width() < 750) {
            playOnClick = true;
        } else if (window.mobileCheck()) {
            playOnClick = true;
        }
        if (playOnClick) {
            setAutoplaySupport(false);
        }
        playOnClickChecked = true;
    }
    function onPlayerReady(evt) {
        evt.target.setPlaybackQuality("hd1080");
        var videoData = getVideoOptions(evt.target.b.b);
        playOnClickCheck();
        $("#" + videoData.id).attr("tabindex", "-1");
        sizeBackgroundVideos();
        switch (videoData.type) {
            case "background-chrome":
            case "background":
                evt.target.mute();
                if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
                    privatePlayVideo(videoData.id);
                }
                break;
        }
        videoData.$parentSlide.addClass(classes.loaded);
    }
    function onPlayerChange(evt) {
        var videoData = getVideoOptions(evt.target.b.b);
        switch (evt.data) {
            case 0:
                setAsFinished(videoData);
                break;
            case 1:
                setAsPlaying(videoData);
                break;
            case 2:
                setAsPaused(videoData);
                break;
        }
    }
    function setAsFinished(videoData) {
        switch (videoData.type) {
            case "background":
                videoPlayers[videoData.id].seekTo(0);
                break;
            case "background-chrome":
                videoPlayers[videoData.id].seekTo(0);
                closeVideo(videoData.id);
                break;
            case "chrome":
                closeVideo(videoData.id);
                break;
        }
    }
    function setAsPlaying(videoData) {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        $slide.removeClass(classes.loading);
        if (videoData.status === "background") {
            return;
        }
        $("#" + videoData.id).attr("tabindex", "0");
        switch (videoData.type) {
            case "chrome":
            case "background-chrome":
                $slideshow.removeClass(classes.paused).addClass(classes.playing);
                $slide.removeClass(classes.paused).addClass(classes.playing);
                break;
        }
        $slide.find("." + classes.closeVideoBtn).focus();
    }
    function setAsPaused(videoData) {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        if (videoData.type === "background-chrome") {
            closeVideo(videoData.id);
            return;
        }
        if (videoData.status !== "closed" && videoData.type !== "background") {
            $slideshow.addClass(classes.paused);
            $slide.addClass(classes.paused);
        }
        if (videoData.type === "chrome" && videoData.status === "closed") {
            $slideshow.removeClass(classes.paused);
            $slide.removeClass(classes.paused);
        }
        $slideshow.removeClass(classes.playing);
        $slide.removeClass(classes.playing);
    }
    function closeVideo(playerId) {
        var videoData = videos[playerId];
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        var classesToRemove = [classes.pause, classes.playing].join(" ");
        $("#" + videoData.id).attr("tabindex", "-1");
        videoData.status = "closed";
        switch (videoData.type) {
            case "background-chrome":
                videoPlayers[playerId].mute();
                setBackgroundVideo(playerId);
                break;
            case "chrome":
                videoPlayers[playerId].stopVideo();
                setAsPaused(videoData);
                break;
        }
        $slideshow.removeClass(classesToRemove);
        $slide.removeClass(classesToRemove);
    }
    function getVideoOptions(evt) {
        return videos[evt.id];
    }
    function startVideoOnClick(playerId) {
        var videoData = videos[playerId];
        videoData.$parentSlide.addClass(classes.loading);
        videoData.status = "open";
        switch (videoData.type) {
            case "background-chrome":
                unsetBackgroundVideo(playerId, videoData);
                videoPlayers[playerId].unMute();
                privatePlayVideo(playerId, true);
                break;
            case "chrome":
                privatePlayVideo(playerId, true);
                break;
        }
        $(document).on("keydown.videoPlayer", function (evt) {
            if (evt.keyCode === 27) {
                closeVideo(playerId);
            }
        });
    }
    function sizeBackgroundVideos() {
        $("." + classes.videoBackground).each(function (index, el) {
            sizeBackgroundVideo($(el));
        });
    }
    function sizeBackgroundVideo($player) {
        var $slide = $player.closest("." + classes.slide);
        if ($slide.hasClass(classes.slickClone)) {
            return;
        }
        var slideWidth = $slide.width();
        var playerWidth = $player.width();
        var playerHeight = $player.height();
        if (slideWidth / videoOptions.ratio < playerHeight) {
            playerWidth = Math.ceil(playerHeight * videoOptions.ratio);
            $player
                .width(playerWidth)
                .height(playerHeight)
                .css({ left: (slideWidth - playerWidth) / 2, top: 0 });
        } else {
            playerHeight = Math.ceil(slideWidth / videoOptions.ratio);
            $player
                .width(slideWidth)
                .height(playerHeight)
                .css({ left: 0, top: (playerHeight - playerHeight) / 2 });
        }
        $player.prepareTransition().addClass(classes.loaded);
    }
    function unsetBackgroundVideo(playerId) {
        $("#" + playerId)
            .removeAttr("style")
            .removeClass(classes.videoBackground)
            .addClass(classes.videoChrome);
        videos[playerId].$parentSlideshowWrapper.removeClass(classes.slideBackgroundVideo).addClass(classes.playing);
        videos[playerId].$parentSlide.removeClass(classes.slideBackgroundVideo).addClass(classes.playing);
        videos[playerId].status = "open";
    }
    function setBackgroundVideo(playerId) {
        var $player = $("#" + playerId)
            .addClass(classes.videoBackground)
            .removeClass(classes.videoChrome);
        videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);
        videos[playerId].status = "background";
        sizeBackgroundVideo($player);
    }
    function initEvents() {
        $(document).on("click.videoPlayer", "." + classes.playVideoBtn, function (evt) {
            var playerId = $(evt.currentTarget).data("controls");
            startVideoOnClick(playerId);
        });
        $(document).on("click.videoPlayer", "." + classes.closeVideoBtn, function (evt) {
            var playerId = $(evt.currentTarget).data("controls");
            closeVideo(playerId);
        });
        $(window).on(
            "resize.videoPlayer",
            $.debounce(250, function () {
                if (youtubeLoaded) {
                    sizeBackgroundVideos();
                }
            })
        );
    }
    function removeEvents() {
        $(document).off(".videoPlayer");
        $(window).off(".videoPlayer");
    }
    return { init: init, loadVideos: loadVideos, loadVideo: loadVideo, playVideo: customPlayVideo, pauseVideo: pauseVideo, removeEvents: removeEvents };
})();
if ($(window).width() < 768) {
    $(".flag").on("click", function () {
        $(".mobile-nav-wrapper .selected-currency").trigger("click");
    });
}
(function () {
    var $filterBy = $("#BlogTagFilter");
    if (!$filterBy.length) {
        return;
    }
    $filterBy.on("change", function () {
        location.href = $(this).val();
    });
})();
window.theme = theme || {};
theme.customerTemplates = (function () {
    function initEventListeners() {
        $("#RecoverPassword").on("click", function (evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        });
        $("#HideRecoverPasswordLink").on("click", function (evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        });
    }
    function toggleRecoverPasswordForm() {
        $("#RecoverPasswordForm").toggleClass("hide");
        $("#CustomerLoginForm").toggleClass("hide");
    }
    function resetPasswordSuccess() {
        var $formState = $(".reset-password-success");
        if (!$formState.length) {
            return;
        }
        $("#ResetSuccess").removeClass("hide");
        $("#CustomerLoginForm").addClass("hide");
    }
    function customerAddressForm() {
        var $newAddressForm = $("#AddressNewForm");
        if (!$newAddressForm.length) {
            return;
        }
        if (Shopify) {
            new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" });
        }
        $(".address-country-option").each(function () {
            var formId = $(this).data("form-id");
            var countrySelector = "AddressCountry_" + formId;
            var provinceSelector = "AddressProvince_" + formId;
            var containerSelector = "AddressProvinceContainer_" + formId;
            new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, { hideElement: containerSelector });
        });
        $(".address-new-toggle").on("click", function () {
            $newAddressForm.toggleClass("hide");
        });
        $(".address-edit-toggle").on("click", function () {
            var formId = $(this).data("form-id");
            $("#EditAddress_" + formId).toggleClass("hide");
        });
        $(".address-delete").on("click", function () {
            var $el = $(this);
            var formId = $el.data("form-id");
            var confirmMessage = $el.data("confirm-message");
            if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
                Shopify.postLink("/account/addresses/" + formId, { parameters: { _method: "delete" } });
            }
        });
    }
    function checkUrlHash() {
        var hash = window.location.hash;
        if (hash === "#recover") {
            toggleRecoverPasswordForm();
        }
    }
    return {
        init: function () {
            checkUrlHash();
            initEventListeners();
            resetPasswordSuccess();
            customerAddressForm();
        },
    };
})();
window.theme = window.theme || {};
theme.navigationmenu = (function () {
    var selectors = { body: "body", sitenav: "#siteNav", navLinks: "#siteNav .lvl1 > a", menuToggle: ".js-mobile-nav-toggle", mobilenav: ".mobile-nav-wrapper", menuLinks: "#MobileNav .fa", closemenu: ".closemobileMenu #closeMobileMenu1" };
    $(selectors.navLinks).each(function () {
        if ($(this).attr("href") == window.location.pathname) $(this).addClass("active");
    });
    $(selectors.menuToggle).on("click", function () {
      body: "body";
      $(selectors.mobilenav).toggleClass("active");
      $(selectors.body).toggleClass("menuOn");
      $("html").toggleClass("sticky-search-drawer");
      $(selectors.menuToggle).toggleClass("mobile-nav--open mobile-nav--close");
    });
    $(selectors.closemenu).on("click", function (e) {
      body: "body", $(selectors.mobilenav).toggleClass("active");
      $(selectors.body).toggleClass("menuOn");
      $("html").toggleClass("sticky-search-drawer");
      $(selectors.menuToggle).toggleClass("mobile-nav--open mobile-nav--close");
      $(this).parent("ul").removeClass("active");
    });
    $(selectors.menuLinks).on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("fa-plus fa-minus");
      $(this).parent().next().slideToggle();
    });

    // var selectors_new = { body: "body", menuToggle: ".language-convertor" };
    // $(selectors_new.menuToggle).on("click", function () {
    //   body: "body";
    //   $(selectors.mobilenav).removeClass("active");
    //   $(selectors.body).removeClass("menuOn");
    //   $(selectors.menuToggle).toggleClass("mobile-nav--open mobile-nav--close");
    // });
})();
window.theme = window.theme || {};
theme.Cart = (function () {
    var selectors = { edit: ".js-edit-toggle" };
    var config = { showClass: "cart__update--show", showEditClass: "cart__edit--active", cartNoCookies: "cart--no-cookies" };
    function Cart(container) {
        this.$container = $(container);
        this.$edit = $(selectors.edit, this.$container);
        if (!this.cookiesEnabled()) {
            this.$container.addClass(config.cartNoCookies);
        }
        this.$edit.on("click", this._onEditClick.bind(this));
    }
    Cart.prototype = _.assignIn({}, Cart.prototype, {
        onUnload: function () {
            this.$edit.off("click", this._onEditClick);
        },
        _onEditClick: function (evt) {
            var $evtTarget = $(evt.target);
            var $updateLine = $("." + $evtTarget.data("target"));
            $evtTarget.toggleClass(config.showEditClass);
            $updateLine.toggleClass(config.showClass);
        },
        cookiesEnabled: function () {
            var cookieEnabled = navigator.cookieEnabled;
            if (!cookieEnabled) {
                document.cookie = "testcookie";
                cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
            }
            return cookieEnabled;
        },
    });
    return Cart;
})();
window.theme = window.theme || {};
theme.Filters = (function () {
    var constants = { SORT_BY: "sort_by" };
    var selectors = { filterSelection: ".filters-toolbar__input--filter", sortSelection: ".filters-toolbar__input--sort", defaultSort: ".collection-header__default-sort" };
    function Filters(container) {
        var $container = (this.$container = $(container));
        this.$filterSelect = $(selectors.filterSelection, $container);
        this.$sortSelect = $(selectors.sortSelection, $container);
        this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));
        this.defaultSort = this._getDefaultSortValue();
        this._resizeSelect(this.$selects);
        this.$selects.removeClass("hidden");
        this.$filterSelect.on("change", this._onFilterChange.bind(this));
        this.$sortSelect.on("change", this._onSortChange.bind(this));
    }
    Filters.prototype = _.assignIn({}, Filters.prototype, {
        _onSortChange: function (evt) {
            var sort = this._sortValue();
            if (sort.length) {
                window.location.search = sort;
            } else {
                window.location.href = window.location.href.replace(window.location.search, "");
            }
            this._resizeSelect($(evt.target));
        },
        _onFilterChange: function (evt) {
            window.location.href = this.$filterSelect.val() + window.location.search;
            this._resizeSelect($(evt.target));
        },
        _getSortValue: function () {
            return this.$sortSelect.val() || this.defaultSort;
        },
        _getDefaultSortValue: function () {
            return $(selectors.defaultSort, this.$container).val();
        },
        _sortValue: function () {
            var sort = this._getSortValue();
            var query = "";
            if (sort !== this.defaultSort) {
                query = constants.SORT_BY + "=" + sort;
            }
            return query;
        },
        _resizeSelect: function ($selection) {
            $selection.each(function () {
                var $this = $(this);
                var arrowWidth = 10;
                var text = $this.find("option:selected").text();
                var $test = $("<span>").html(text);
                $test.appendTo("body");
                var width = $test.width();
                $test.remove();
                $this.width(width + arrowWidth);
            });
        },
        onUnload: function () {
            this.$filterSelect.off("change", this._onFilterChange);
            this.$sortSelect.off("change", this._onSortChange);
        },
    });
    return Filters;
})();
window.theme = window.theme || {};
$(window).scroll(function () {
    if ($("#CartCount").text() != 0) {
        if ($(".header-wrap").hasClass("stickyNav")) {
            var headerHeight = $("#shopify-section-header .header-wrap").height();
        } else {
            var headerHeight = $("#shopify-section-header").height();
        }
        //$("#header-cart").css("top", headerHeight);
    }
});
theme.HeaderSection = (function () {
    function Header() {
        theme.Header.init();
        theme.Search.init();
        if (!$("#header-cart").hasClass("activeCart")) $("#header-cart").addClass("activeCart");
        $(".closeBtn .btnClose").css("top", "10px");
        $(".site-header__cart").click(function (i) {
            i.preventDefault();
            if ($(".customer-links").is(":visible")) {
                $(".site-header .user-menu").trigger("click");
            }
            if ($(".currencies").is(":visible")) {
                $(".currencies").slideUp();
            }
            if ($("#CartCount").text() != 0) {
                if ($(".header-wrap").hasClass("stickyNav")) {
                    var headerHeight = $("#shopify-section-header .header-wrap").height();
                } else {
                    var headerHeight = $("#shopify-section-header").height();
                }
                //$("#header-cart").css("top", headerHeight);
                //$("body").toggleClass("cart-open");
                $("#header-cart").toggleClass("activeCartToggle");
            } else {
                i.preventDefault();
                if ($(".header-wrap").hasClass("stickyNav")) {
                    var headerHeight = $("#shopify-section-header .header-wrap").height();
                } else {
                    var headerHeight = $("#shopify-section-header").height();
                }
                //$("#header-cart").css("top", headerHeight);
                if (!$("#header-cart").hasClass("activeCart")) $("#header-cart").addClass("activeCart");
                $("#header-cart").toggleClass("activeCartToggle");
                $("#cart-title").css("color", "#000");
                //$("#header-cart").toggle("slide", { direction: "left" }, 3000);
                $(".closeBtn .btnClose").css("top", "10px");
                if ($("#header-cart").hasClass("activeCartToggle")) $("body").addClass("cart-open"), $("html").addClass("back-fixed");
                else $("body").removeClass("cart-open"), $("html").removeClass("back-fixed");
            }
        });
        $("body").click(function (event) {
            var $target = $(event.target);
            if (!$target.parents().is(".site-cart") && !$target.is(".site-cart")) {
                //$("body").find("#header-cart").slideUp();
                if ($("#CartCount").text() != 0) {
                    $("body").removeClass("cart-open");
                    $("html").removeClass("back-fixed");
                    $("#header-cart").removeClass("activeCartToggle");
                } else {
                    $("body").removeClass("cart-open");
                    $("html").removeClass("back-fixed");
                    if (!$("#header-cart").hasClass("activeCart")) $("#header-cart").addClass("activeCart");
                    $("#header-cart").removeClass("activeCartToggle");
                    $("#header-cart").hide();
                }
            }
            if (!$target.parents().is("#mobile_navigation") && !$target.is("#mobile_navigation") && !$target.is(".icon-hamburger") && !$target.is(".site-header__menu")) {
                if ($(window).width() < 800) {
                    if ($("body").hasClass("menuOn")) {
                        if ($(".currencies").is(":visible")) {
                            $("#closeCurrencies").trigger("click");
                        } else {
                            $("#closeMobileMenu").trigger("click");
                        }
                    }
                }
            }
        });
        $("#closeCurrencies").on("click", function () {
            $(".currencies").slideUp();
        });
    }
    Header.prototype = _.assignIn({}, Header.prototype, {
        onUnload: function () {
            theme.Header.unload();
        },
    });
    return Header;
})();
theme.Maps = (function () {
    var config = { zoom: 14 };
    var apiStatus = null;
    var mapsToLoad = [];
    var key = theme.mapKey ? theme.mapKey : "";
    function Map(container) {
        this.$container = $(container);
        if (apiStatus === "loaded") {
            this.createMap();
        } else {
            mapsToLoad.push(this);
            if (apiStatus !== "loading") {
                apiStatus = "loading";
                if (typeof window.google === "undefined") {
                    $.getScript("https://maps.googleapis.com/maps/api/js?key=" + key).then(function () {
                        apiStatus = "loaded";
                        initAllMaps();
                    });
                }
            }
        }
    }
    function initAllMaps() {
        $.each(mapsToLoad, function (index, instance) {
            instance.createMap();
        });
    }
    function geolocate($map) {
        var deferred = $.Deferred();
        var geocoder = new google.maps.Geocoder();
        var address = $map.data("address-setting");
        geocoder.geocode({ address: address }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
                deferred.reject(status);
            }
            deferred.resolve(results);
        });
        return deferred;
    }
    Map.prototype = _.assignIn({}, Map.prototype, {
        createMap: function () {
            var $map = this.$container.find(".map-section__container");
            return geolocate($map)
                .then(
                    function (results) {
                        var mapOptions = { zoom: config.zoom, center: results[0].geometry.location, disableDefaultUI: true };
                        var map = (this.map = new google.maps.Map($map[0], mapOptions));
                        var center = (this.center = map.getCenter());
                        var marker = new google.maps.Marker({ map: map, position: map.getCenter() });
                        google.maps.event.addDomListener(
                            window,
                            "resize",
                            $.debounce(250, function () {
                                google.maps.event.trigger(map, "resize");
                                map.setCenter(center);
                            })
                        );
                    }.bind(this)
                )
                .fail(function () {
                    var errorMessage;
                    switch (status) {
                        case "ZERO_RESULTS":
                            errorMessage = theme.strings.addressNoResults;
                            break;
                        case "OVER_QUERY_LIMIT":
                            errorMessage = theme.strings.addressQueryLimit;
                            break;
                        default:
                            errorMessage = theme.strings.addressError;
                            break;
                    }
                    $map.parent()
                        .addClass("page-width map-section--load-error")
                        .html('<div class="errors text-center">' + errorMessage + "</div>");
                });
        },
        onUnload: function () {
            google.maps.event.clearListeners(this.map, "resize");
        },
    });
    return Map;
})();
function gm_authFailure() {
    $(".map-section").addClass("map-section--load-error");
    $(".map-section__container").remove();
    $(".map-section__link").remove();
    $(".map-section__overlay").after('<div class="errors text-center">' + theme.strings.authError + "</div>");
}
theme.Product = (function () {
    function Product(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");
        thumbnails = $(".product-single__thumbnail-image");
        if (thumbnails.length) {
            thumbnails.bind("click", function () {
                var arrImage = $(this).attr("src").split("?")[0].split(".");
                var strExtention = arrImage.pop();
                var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, "");
                var strNewImage = arrImage.join(".") + "." + strRemaining + "." + strExtention;
                if (typeof variantImages[strNewImage] !== "undefined") {
                    productOptions.forEach(function (value, i) {
                        optionValue = variantImages[strNewImage]["option-" + i];
                        if (
                            optionValue !== null &&
                            $(".single-option-selector:eq(" + i + ") option").filter(function () {
                                return $(this).text() === optionValue;
                            }).length
                        ) {
                            $(".swatch-" + i)
                                .find('.swatchInput[value="' + optionValue + '"]')
                                .prop("checked", true);
                            $(".single-option-selector:eq(" + i + ")")
                                .val(optionValue)
                                .trigger("change");
                        }
                    });
                }
            });
        }
        var sliderRelatedAnimationSpeed = $container.attr("proRelated-aniamtion");
        var sliderRelatedToShow = $container.attr("proRelated-num");
        var sliderRelatedAutoSpeed = $container.attr("proRelated-timeout");
        var sliderRelatedAuto = $container.attr("proRelated-autoplay");
        var tabs = (this.tabs = "#ProductSection-" + sectionId + " .tablink");
        $(tabs).on("click", function (e) {
            e.preventDefault();
            $(this).parent().addClass("active");
            $(this).parent().siblings().removeClass("active");
            var tab = $(this).attr("href");
            $(".tab-content").not(tab).css("display", "none");
            $(tab).fadeIn();
            if ($(window).width() < 767) {
                var tabposition = $(this).offset();
                $("html, body").animate({ scrollTop: tabposition.top }, 700);
            }
        });
        $(".product-tabs li:first-child").addClass("active");
        $(".tab-container h3:first-child + .tab-content").show();
        $(".related-product .collection_matrix_list").slick({
            dots: false,
            infinite: true,
            slidesToShow: sliderRelatedToShow,
            autoplaySpeed: sliderRelatedAutoSpeed,
            speed: sliderRelatedAnimationSpeed,
            slidesToScroll: 1,
            autoplay: sliderRelatedAuto,
            rtl: theme.rtl,
            responsive: [
                { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1 } },
                { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                { breakpoint: 750, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            ],
        });
        this.settings = {
            mediaQueryMediumUp: "screen and (min-width: 750px)",
            mediaQuerySmall: "screen and (max-width: 749px)",
            bpSmall: false,
            enableHistoryState: $container.data("enable-history-state") || false,
            imageSize: null,
            imageZoomSize: null,
            namespace: ".slideshow-" + sectionId,
            sectionId: sectionId,
            sliderActive: false,
            zoomEnabled: false,
        };
        this.selectors = {
            addToCart: "#AddToCart-" + sectionId,
            addToCartText: "#AddToCartText-" + sectionId,
            comparePrice: "#ComparePrice-" + sectionId,
            originalPrice: "#ProductPrice-" + sectionId,
            SKU: ".variant-sku",
            originalPriceWrapper: ".product-price__price-" + sectionId,
            originalSelectorId: "#ProductSelect-" + sectionId,
            productFeaturedImage: "#FeaturedImage-" + sectionId,
            productImageWrap: "#FeaturedImageZoom-" + sectionId,
            productPrices: ".product-single__price-" + sectionId,
            productThumbImages: ".product-single__thumbnail--" + sectionId,
            productThumbs: ".product-single__thumbnails-" + sectionId,
            saleClasses: "product-price__sale product-price__sale--single",
            saleLabel: ".product-price__sale-label-" + sectionId,
            singleOptionSelector: ".single-option-selector-" + sectionId,
        };
        if (!$("#ProductJson-" + sectionId).html()) {
            return;
        }
              
              
        if($(".active_pro").length > 0){
         this.productSingleObject = JSON.parse(document.querySelector(".active_pro").innerHTML);
        }else{
         this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + sectionId).innerHTML);
        }
             
        //this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + sectionId).innerHTML);
        this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass("js-zoom-enabled");
        this.settings.imageSize = theme.Images.imageSize($(this.selectors.productFeaturedImage).attr("src"));
        if (this.settings.zoomEnabled) {
            this.settings.imageZoomSize = theme.Images.imageSize($(this.selectors.productImageWrap).data("zoom"));
        }
        this._initBreakpoints();
        this._stringOverrides();
        this._initVariants();
        this._initImageSwitch();
        this._setActiveThumbnail();
        theme.Images.preload(this.productSingleObject.images, this.settings.imageSize);
    }
    Product.prototype = _.assignIn({}, Product.prototype, {
        _stringOverrides: function () {
            theme.productStrings = theme.productStrings || {};
            $.extend(theme.strings, theme.productStrings);
        },
        _initBreakpoints: function () {
            var self = this;
            enquire.register(this.settings.mediaQuerySmall, {
                match: function () {
                    if ($(self.selectors.productThumbImages).length > 3) {
                        self._initThumbnailSlider();
                    }
                    if (self.settings.zoomEnabled) {
                        _destroyZoom($(self.selectors.productImageWrap));
                    }
                    self.settings.bpSmall = true;
                },
                unmatch: function () {
                    if (self.settings.sliderActive) {
                        self._destroyThumbnailSlider();
                    }
                    self.settings.bpSmall = false;
                },
            });
            enquire.register(this.settings.mediaQueryMediumUp, {
                match: function () {
                    if ($(self.selectors.productThumbImages).length > 3) {
                        self._initThumbnailSlider();
                    }
                    if (self.settings.zoomEnabled) {
                        _enableZoom($(self.selectors.productImageWrap));
                    }
                },
            });
        },
        _initVariants: function () {
            var options = {
                $container: this.$container,
                enableHistoryState: this.$container.data("enable-history-state") || false,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.productSingleObject,
            };
            
            this.variants = new slate.Variants(options);
            this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this));
            this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this));
            this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this));
            this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this));
        },
        _initImageSwitch: function () {
            if (!$(this.selectors.productThumbImages).length) {
                return;
            }
            var self = this;
            $(this.selectors.productThumbImages).on("click", function (evt) {
                evt.preventDefault();
                var $el = $(this);
                var imageSrc = $el.attr("href");
                var zoomSrc = $el.data("zoom");
                self._switchImage(imageSrc, zoomSrc);
                self._setActiveThumbnail(imageSrc);
            });
        },
        _setActiveThumbnail: function (src) {
            var activeClass = "active-thumb";
            if (typeof src === "undefined") {
                src = $(this.selectors.productFeaturedImage).attr("src");
            }
            var $thumbnail = $(this.selectors.productThumbImages + '[href="' + src + '"]');
            $(this.selectors.productThumbImages).removeClass(activeClass);
            $thumbnail.addClass(activeClass);
        },
        _switchImage: function (image, zoomImage) {
            $(this.selectors.productFeaturedImage).attr("src", image);
            if (this.settings.zoomEnabled) {
                _destroyZoom($(this.selectors.productImageWrap));
            }
            if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {
                $(this.selectors.productImageWrap).data("zoom", zoomImage);
                _enableZoom($(this.selectors.productImageWrap));
            }
        },
        _initThumbnailSlider: function () {
            var windowWidth = $(window).width(),
                thumbStyle = true;
            if (windowWidth <= 749) {
                thumbStyle = false;
            } else {
                thumbStyle = true;
            }
            var options = {
                verticalSwiping: true,
                vertical: thumbStyle,
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: false,
                rtl: theme.rtl,
                prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
                nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
                responsive: [{ breakpoint: 750, settings: { slidesToShow: 4, vertical: false, swipe: true, verticalSwiping: false, draggable: false } }],
            };
            $(this.selectors.productThumbs).slick(options);
            this.settings.sliderActive = true;
        },
        _destroyThumbnailSlider: function () {
            $(this.selectors.productThumbs).slick("unslick");
            this.settings.sliderActive = false;
        },
        _updateAddToCart: function (evt) {
            var variant = evt.variant;
          var element = document.getElementById("notify_me_btn");
          
          if(typeof(element) != 'undefined' && element != null){
          }else{
            if (variant) {
              $(this.selectors.productPrices).removeClass("visibility-hidden").attr("aria-hidden", "true");
              if (variant.available) {
                $(this.selectors.addToCart).prop("disabled", false);
                $(this.selectors.addToCartText).text(theme.strings.addToCart);
                $(".instock").removeClass("hide");
                $(".outstock").addClass("hide");
                $("#quantity_message").show().find(".items").text(variant.inventory_quantity);
              } else {
                $(this.selectors.addToCart).prop("disabled", true);
                $(this.selectors.addToCartText).text(theme.strings.soldOut);
                $(".instock").addClass("hide");
                $(".outstock").removeClass("hide");
                $("#quantity_message").hide();
              }
            } else {
              $(this.selectors.addToCart).prop("disabled", true);
              $(this.selectors.addToCartText).text(theme.strings.unavailable);
              $(this.selectors.productPrices).addClass("visibility-hidden").attr("aria-hidden", "false");
              $(".instock").addClass("hide");
              $(".outstock").removeClass("hide");
              $("#quantity_message").hide();
            }
          }
        },
        _updateImages: function (evt) {
            var variant = evt.variant;
            var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
            var zoomSizedImgUrl;
            if (this.settings.zoomEnabled) {
                zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
            }
            this._switchImage(sizedImgUrl, zoomSizedImgUrl);
            this._setActiveThumbnail(sizedImgUrl);
        },
        _updatePrice: function (evt) {
            var variant = evt.variant;
            $(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
            if (variant.compare_at_price > variant.price) {
                $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).removeClass("hide");
                $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);
                $(this.selectors.saleLabel).removeClass("hide");
            } else {
                $(this.selectors.comparePrice).addClass("hide");
                $(this.selectors.saleLabel).addClass("hide");
                $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
            }
        },
        _updateSKU: function (evt) {
            var variant = evt.variant;
            $(this.selectors.SKU).html(variant.sku);
        },
        onUnload: function () {
            this.$container.off(this.settings.namespace);
        },
    });
    function _enableZoom($el) {
        var zoomUrl = $el.data("zoom");
        $el.zoom({ url: zoomUrl });
    }
    function _destroyZoom($el) {
        $el.trigger("zoom.destroy");
    }
    return Product;
})();
theme.QuickView = (function () {
    $("body").on("click", ".quick-view", function (e) {
        $.ajax({
            beforeSend: function () {
                $("body").addClass("line-loading");
            },
            url: $(this).attr("href"),
            success: function (data) {
                $.magnificPopup.open({
                    items: { src: '<div class="quick-view-popup" id="content_quickview">' + data + "</div>", type: "inline" },
                    removalDelay: 500,
                    callbacks: {
                        beforeOpen: function () {
                            this.st.mainClass = "mfp-move-horizontal";
                        },
                        open: function () {
                            $(".product-photoslider").slick({ dots: false, infinite: true, speed: 300, rtl: theme.rtl, slidesToShow: 1, slidesToScroll: 1 });
                        },
                        close: function () {
                            $("#content_quickview").empty();
                        },
                    },
                });
            },
            complete: function () {
                $("body").removeClass("line-loading");
            },
        });
        e.preventDefault();
        e.stopPropagation();
    });
})();
theme.Quotes = (function () {
    var config = { mediaQuerySmall: "screen and (max-width: 749px)", mediaQueryMediumUp: "screen and (min-width: 750px)", slideCount: 0 };
    var defaults = { accessibility: true, arrows: true, dots: false, autoplay: false, rtl: theme.rtl, touchThreshold: 20, slidesToShow: 1, slidesToScroll: 1 };
    function Quotes(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");
        var wrapper = (this.wrapper = ".quotes-wrapper");
        var slider = (this.slider = "#Quotes-" + sectionId);
        var $slider = $(slider, wrapper);
        var sliderActive = false;
        var mobileOptions = $.extend({}, defaults, { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: true });
        config.slideCount = $slider.data("count");
        if (config.slideCount < defaults.slidesToShow) {
            defaults.slidesToShow = config.slideCount;
            defaults.slidesToScroll = config.slideCount;
        }
        $slider.on("init", this.a11y.bind(this));
        enquire.register(config.mediaQuerySmall, {
            match: function () {
                initSlider($slider, mobileOptions);
            },
        });
        enquire.register(config.mediaQueryMediumUp, {
            match: function () {
                initSlider($slider, defaults);
            },
        });
        function initSlider(sliderObj, args) {
            if (sliderActive) {
                sliderObj.slick("unslick");
                sliderActive = false;
            }
            sliderObj.slick(args);
            sliderActive = true;
        }
    }
    Quotes.prototype = _.assignIn({}, Quotes.prototype, {
        onUnload: function () {
            enquire.unregister(config.mediaQuerySmall);
            enquire.unregister(config.mediaQueryMediumUp);
            $(this.slider, this.wrapper).slick("unslick");
        },
        onBlockSelect: function (evt) {
            var $slide = $(".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)");
            var slideIndex = $slide.data("slick-index");
            $(this.slider, this.wrapper).slick("slickGoTo", slideIndex);
        },
        a11y: function (event, obj) {
            var $list = obj.$list;
            var $wrapper = $(this.wrapper, this.$container);
            $list.removeAttr("aria-live");
            $wrapper.on("focusin", function (evt) {
                if ($wrapper.has(evt.target).length) {
                    $list.attr("aria-live", "polite");
                }
            });
            $wrapper.on("focusout", function (evt) {
                if ($wrapper.has(evt.target).length) {
                    $list.removeAttr("aria-live");
                }
            });
        },
    });
    return Quotes;
})();
theme.slideshows = {};
theme.SlideshowSection = (function () {
    function SlideshowSection(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");
        var slideshow = (this.slideshow = "#Slideshow-" + sectionId);
        $(".slideshow__video", slideshow).each(function () {
            var $el = $(this);
            theme.SlideshowVideo.init($el);
            theme.SlideshowVideo.loadVideo($el.attr("id"));
        });
        theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    }
    return SlideshowSection;
})();
theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
    onUnload: function () {
        delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function (evt) {
        var $slideshow = $(this.slideshow);
        var $slide = $(".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)");
        var slideIndex = $slide.data("slick-index");
        $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
    },
    onBlockDeselect: function () {
        $(this.slideshow).slick("slickPlay");
    },
});
theme.collectionView = (function () {
    function collectionView(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");
        var sliderSecond = $container.attr("data-section-timeout");
        ajaxfilter = function (url) {
            var urlparam = getSearchParams(),
                urlparam = $.param(urlparam);
            if (urlparam) {
                var splite_url = url.split("?");
                url = splite_url[0];
            }
            $.ajax({
                type: "GET",
                url: url,
                data: {},
                beforeSend: function () {
                    $("body").addClass("line-loading hideOverly");
                },
                complete: function (data) {
                    $(".productList .collection_matrix_list").html($(".productList .collection_matrix_list", data.responseText).html());
                    $(".productList .collection_matrix_list").html($(".productList .collection_matrix_list", data.responseText).html());
                    $(".filters-toolbar__product-count").html($(".filters-toolbar__product-count", data.responseText).html());
                    $(".sidebar_tags").html($(".sidebar_tags", data.responseText).html());
                    check_filters();
                    $(".pagination").html($(".pagination", data.responseText).html());
                    if (!$(".pagination", data.responseText).html()) {
                        $(".pagination").hide();
                    } else {
                        $(".pagination").show();
                    }
                    $(".infinitpaginOuter").html($(".infinitpaginOuter", data.responseText).html());
                    if (!$(".infinitpaginOuter", data.responseText).html()) {
                        $(".infinitpagin").remove();
                    }
                    $("body").removeClass("line-loading hideOverly");
                    $(theme.colorSwatches);
                    $(theme.ajaxCart);
                    infiniteScroll();
                    loadMoreBtn();
                    if ($(".spr-badge").length > 0) {
                        $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
                    }
                    productGridView(sectionId);
                    setTimeout(function () {
                        productGridView(sectionId);
                    }, 1000);
                    history.pushState({ page: url }, url, url);
                },
            });
        };
        function getSearchParams(k) {
            var p = {};
            location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
                p[k] = v;
            });
            return k ? p[k] : p;
        }
        $(window).on("load delayed-resize", function (e, resizeEvent) {
            productGridView(sectionId);
        });
        infiniteScroll = function () {
            $(window).on("scroll load delayed-resize", function () {
                var moreURL = $(".infinitpagin a").attr("href");
                if ($(".infinitpagin a.infinite").length) {
                    var bottom = $(".infinitpagin").offset();
                    var docTop = $(document).scrollTop() + $(window).height() - 50;
                    
                    if (docTop > bottom.top) {
                        $(window).off("scroll load delayed-resize");
                        loadMore(moreURL);
                    }
                }
            });
        };
        loadMoreBtn = function () {
          $(document).one("click", ".infinitpagin a.loadMore", (e) => {
            //$(".infinitpagin a.loadMore").click(function (e) {
                e.preventDefault();
                var moreURL = $(e.currentTarget).attr("href");
                loadMore(moreURL);
            //});
          })
        };
        loadMore = function (moreURL) {
            if (moreURL.length) {
                $.ajax({
                    type: "GET",
                    dataType: "html",
                    url: moreURL,
                    beforeSend: function () {
                        if ($(".infinitpaginOuter").attr("data-type") == "button") {
                            $("body").addClass("line-loading hideOverly");
                        } else {
                            $(".infinitpagin a").show();
                        }
                    },
                    complete: function (data) {
                        if ($(".productList .collection_matrix_list").length) {
                            $(".productList .collection_matrix_list").append($(".productList .collection_matrix_list", data.responseText).html());
                        } else {
                            $(".productList .list-view-items").append($(".productList .list-view-items", data.responseText).html());
                        }
                        if ($(".infinitpagin", data.responseText).html()) {
                            $(".infinitpagin").html($(".infinitpagin", data.responseText).html());
                        } else {
                            $(".infinitpagin").remove();
                        }

                        let display = $(".view_wrappers .display li.current").attr("data-value");
                        $("#Collection").find(".productList .coll_matrix_item").each(function(){
                          let proImage = $(this).find(".pro-list-img").find(".pro__first"),
                              modelImage = $(this).find(".pro-list-img").find(".pro__second");
                          if(display == 'model'){
                            modelImage.hasClass("active") ? (proImage.addClass("active"), modelImage.removeClass("active")) : '';
                          }else if(display == 'product'){
                            if(modelImage.length > 0){
                              proImage.hasClass("active") ? (modelImage.addClass("active"), proImage.removeClass("active")) : '';    
                            }else{}
                          }
                        });
                      
                        $(theme.ajaxCart);
                        $(theme.colorSwatches);
                        productGridView(sectionId);
                        if ($(".spr-badge").length > 0) {
                            $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
                        }
                        setTimeout(function () {
                            productGridView(sectionId);
                        }, 1000);
                        if ($(".infinitpagin a.loadMore").length) {
                            loadMoreBtn();
                        } else {
                            infiniteScroll();
                        }
                        $("body").removeClass("line-loading hideOverly");
                        if (typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") {
                            mlvedaload();
                        }
                    },
                });
            }
        };
        $(document).ready(function () {
            infiniteScroll();
            loadMoreBtn();
        });
    }
    return collectionView;
})();
theme.productSlider = {};
theme.prodcarouselSection = (function () {
    function prodcarouselSection(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr("data-section-id");
        var productSlider = (this.productSlider = "#" + sectionId + " .productSlider");
        var productitems = $container.attr("data-products"),
            tabs = (this.tabs = "#" + sectionId + " .tablink"),
            tabcontent = (this.tabcontent = "#" + sectionId + " .tab-content");
        $(tabs).on("click", function (e) {
            e.preventDefault();
            $(this).parent().addClass("active");
            $(this).parent().siblings().removeClass("active");
            var tab = $(this).attr("href");
            $(tabcontent).not(tab).css("display", "none");
            $(tab).fadeIn();
            prodslider(tab + " .productSlider");
        });
        $("#" + sectionId).each(function () {
            $(this).find(".collection-tabs li:first-child").addClass("active");
            $(this).find(".tab-container h3:first-child + .tab-content").show();
            var firsttab = $(this).find(".collection-tabs li:first-child a").attr("href");
            prodslider(firsttab + " .productSlider");
        });
        function prodslider($slider) {
            $($slider).slick({
                dots: false,
                infinite: true,
                speed: 300,
                centerPadding: 20,
                slidesToShow: productitems,
                slidesToScroll: 1,
                rtl: theme.rtl,
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                    { breakpoint: 750, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                ],
            });
            $($slider).resize();
        }
        $(window).on("load delayed-resize", function (e, resizeEvent) {
            productGridView(sectionId);
        });
    }
    return prodcarouselSection;
})();
function productGridView(sectionId) {
    var gridRows = [];
    var tempRow = [];
    productGridElements = $("#" + sectionId + " .collection_matrix_list .coll_matrix_item");
    productGridElements.each(function (index) {
        if ($(this).css("clear") != "none" && index != 0) {
            gridRows.push(tempRow);
            tempRow = [];
        }
        tempRow.push(this);
        if (productGridElements.length == index + 1) {
            gridRows.push(tempRow);
        }
    });
    $.each(gridRows, function () {
        var tallestHeight = 0;
        var tallestHeight1 = 0;
        $.each(this, function () {
            $(this).find(".grid-view_image a.grid-view-item__link").css("height", "");
            elHeight = parseInt($(this).find(".grid-view_image").css("height"));
            if (elHeight > tallestHeight) {
                tallestHeight = elHeight;
            }
        });
        $.each(this, function () {
            if ($(window).width() > 750) {
                //$(this).find(".grid-view_image > a.grid-view-item__link").css("height", tallestHeight);
            }
        });
    });
}
theme.colorSwatches = function () {
    $(".grid-view-item .swatches li:not(.noImg)").hover(
        function () {
            var newImage = $(this).attr("rel");
            $(this).parents(".grid-view-item").find(".grid-view-item__link").addClass("showLoading");
            $(this).parents(".grid-view-item").find(".variantImg").attr({ src: newImage });
            $(this)
                .parents(".grid-view-item")
                .find(".variantImg")
                .load(function () {
                    $(this).parents(".grid-view-item").find(".grid-view-item__link").addClass("showVariantImg");
                    $(this).parents(".grid-view-item").find(".grid-view-item__link").removeClass("showLoading");
                });
            return false;
        },
        function () {
            $(this).parents(".grid-view-item").find(".grid-view-item__link").removeClass("showLoading");
            $(this).parents(".grid-view-item").find(".grid-view-item__link").removeClass("showVariantImg");
            return false;
        }
    );
};
$(theme.colorSwatches);
theme.instagram = {};
theme.instagramSection = (function () {
    function instagramSection(container) {
        var $container = (this.$container = $(container)),
            sectionId = $container.attr("data-section-id"),
            token = $container.attr("data-token"),
            dataget = $container.attr("data-get"),
            tags = $container.attr("data-tags"),
            user = $container.attr("data-user"),
            imagesize = $container.attr("data-image"),
            num_photos = $container.attr("data-count");
        if (dataget == "tagged") {
            instagramurl = "https://api.instagram.com/v1/tags/" + tags + "/media/recent";
        } else {
            instagramurl = "https://api.instagram.com/v1/users/" + user + "/media/recent";
        }
        $.ajax({
            url: instagramurl,
            dataType: "jsonp",
            type: "GET",
            data: { access_token: token, count: num_photos },
            success: function (data) {
                for (x in data.data) {
                    if (imagesize == "thumbnail") {
                        imageurl = data.data[x].images.thumbnail.url;
                    } else if (imagesize == "standard_resolution") {
                        imageurl = data.data[x].images.standard_resolution.url;
                    } else {
                        imageurl = data.data[x].images.low_resolution.url;
                    }
                    $("#instafeed").append('<div class="insta-img"><a href="' + data.data[x].link + '"><img src="' + imageurl + '"></a></div>');
                }
            },
            error: function (data) {
                console.log(data);
            },
        });
    }
    return instagramSection;
})();
theme.collectionSlider = {};
theme.collectionListBox = (function () {
    function collectionList(container) {
        var $container = (this.$container = $(container)),
            sectionId = $container.attr("data-section-id"),
            collectionSlider = (this.productSlider = "#cs-" + sectionId + " .collection-grid .grid"),
            slidercount = $container.attr("data-section-slide");
        $(collectionSlider).slick({
            dots: false,
            infinite: true,
            slidesToShow: slidercount,
            speed: 600,
            slidesToScroll: 1,
            rtl: theme.rtl,
            responsive: [
                { breakpoint: 1199, settings: { slidesToShow: 4, slidesToScroll: 1 } },
                { breakpoint: 989, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                { breakpoint: 750, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            ],
        });
    }
    return collectionList;
})();
$(document).on("cart.requestComplete", function (event, cart) {
    setTimeout(function () {
        if ($("#CartCount").text() == 0) {
            $("body").removeClass("cart-open");
            $("html").removeClass("back-fixed");
            $("#header-cart").removeClass("activeCartToggle");
            $("#header-cart").removeClass("activeCart");
        }
    }, 500);
});
theme.ajaxCart = function () {
    drawerTimeout: null, gridAddToCart(), prodAddToCart();
    wishlist();
    updateWishlist();
    $(".continue-shopping, .modalOverly, .closeDrawer").click(function () {
        clearTimeout(drawerTimeout), $(".modal").fadeOut(200);
        $("body").removeClass("line-loading showOverly");
    });
    function gridAddToCart() {
        $(".add-to-cart").click(function (i) {
            i.preventDefault();
            if (theme.ajax_cart) {
                var att = $(this).attr("id"),
                    qty = $(this).attr("rel");
                addinToCart(att, qty);
            } else {
                $(this).parent().submit();
            }
            if (typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") {
                mlvedaload();
            }
            return;
        });
    }
    function prodAddToCart() {
        var cartBtn = $(".product-form__cart-submit"),
            pName = $("h1.product-single__title").text(),
            pImg = $(".product-single__photo .product-featured-img").attr("src");
        //$(cartBtn).click(function (i) {
        $(document).on("click", ".product-form__cart-submit", function(i){
            if(this.classList.contains("add_to_cart_btn") || 
               this.classList.contains("restock-alerts-notify-button") || 
               this.classList.contains("restock-alerts-submit-button")){ i.preventDefault(); return; }
            if ((i.preventDefault(), "disabled" != $(this).attr("disabled")))
                if (theme.ajax_cart) {
                    var att = $(".product-form select[name=id]").val();
                    att || (att = $(".product-form input[name=id]").val());
                    var qty = $(".product-form input[name=quantity]").val();
                    qty || (qty = 1);
                    addinToCart(att, qty);
                } else {
                    $(".product-form").submit();
                }
            if (typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") {
                mlvedaload();
            }
            return;
        });
    }
    function addinToCart(att, qty) {
        //$("body").addClass("loading");
        $("body").addClass("line-loading");
        CartJS.addItem(
            att,
            qty,
            {},
            {
              success: function (data, textStatus, jqXHR) {
                $("#successDrawer").find(".modal-prod-img").attr("src", "");
                var pimg = data.image,
                    pimg_path = pimg.replace(/(\.[^\.]*$|$)/, "_small" + "$&");
                $("#successDrawer").find(".modal-prod-img").attr("src", pimg_path);
                $("#successDrawer").find(".modal-prod-name").text(data.product_title);
                console.log(data);
                getCartDrawer();
                setTimeout(function () {
                  $(".site-header__cart").trigger("click");
                  $("body").removeClass("line-loading showOverly");
                  $("html").addClass("back-fixed");
                  if (typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") {
                      mlvedaload();
                  }
                }, 1000);
              },
              error: function (jqXHR, textStatus, errorThrown) {
                var errormsg = JSON.parse(jqXHR.responseText).description;
                $("body").removeClass("line-loading");
                $(".error-message").text(errormsg), showDrawer("#errorDrawer");
              },
            }
        );
    }
    function showDrawer(i) {
        $("body").addClass("line-loading showOverly");
        $(i).fadeIn(500);
        drawerTimeout = setTimeout(function () {
            $("body").removeClass("line-loading showOverly"), $(i).fadeOut(200);
        }, 8000);
    }
    function wishlist() {
        var cookieName = "wishlistList";
        $(".add-to-wishlist").click(function (e) {
            e.preventDefault();
            var id = $(this).attr("href");
            if ($.cookie(cookieName) == null) {
                var str = id;
            } else {
                if ($.cookie(cookieName).indexOf(id) == -1) {
                    var str = $.cookie(cookieName) + "__" + id;
                }
            }
            $.cookie(cookieName, str, { expires: 30, path: "/" });
            $(this).next(".loading-wishlist").css("display", "block");
            $(this).hide();
            setTimeout(function () {
                $('.add-to-wishlist[rel="' + id + '"]')
                    .next(".loading-wishlist")
                    .hide();
                $('.added-wishlist[rel="' + id + '"]').css("display", "block");
            }, 2000);
        });
    }
    function updateWishlist() {
        var cookieName = "wishlistList";
        try {
            if ($.cookie(cookieName) != null && $.cookie(cookieName) != "__" && $.cookie(cookieName) != "") {
                var str = String($.cookie(cookieName)).split("__");
                for (var i = 0; i < str.length; i++) {
                    if (str[i] != "") {
                        $('.added-wishlist[rel="' + str[i] + '"]').css("display", "block");
                        $('.add-to-wishlist[rel="' + str[i] + '"]').hide();
                    }
                }
            }
        } catch (err) {}
    }
};
$(theme.ajaxCart);
$(document).ready(function () {
    var sections = new theme.Sections();
    sections.register("cart-template", theme.Cart);
    sections.register("product", theme.Product);
    sections.register("collection-template", theme.Filters);
    sections.register("collection-template", theme.collectionView);
    sections.register("product-template", theme.Product);
    sections.register("header-section", theme.HeaderSection);
    sections.register("map", theme.Maps);
    sections.register("slideshow-section", theme.SlideshowSection);
    sections.register("carousel-section", theme.prodcarouselSection);
    sections.register("quotes", theme.Quotes);
    sections.register("instagram", theme.instagramSection);
    sections.register("collection-box", theme.collectionListBox);
    $(".selected-currency").click(function () {
        if ($(".customer-links").is(":visible")) {
            $(".customer-links").slideUp();
        }
        $(".currencies").slideToggle();
    });
    $("#currencies li").click(function () {
        var data_img = $(this).attr("data-img");
        var data_country = $(this).attr("data-country-name");
        if ($(window).width() < 768) {
            $(".cntry_name").text(data_country);
        } else {
            $(".flagImg").attr("src", data_img);
            $(".flagImg").css("height", "28px");
            $(this).parents("#currencies").slideUp();
        }
    });
    $(".logo-bar").slick({
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 7,
        slidesToScroll: 1,
        rtl: theme.rtl,
        responsive: [
            { breakpoint: 1100, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 990, settings: { slidesToShow: 5, slidesToScroll: 1 } },
            { breakpoint: 640, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        ],
    });
});
var resizeTimer;
$(window).resize(function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        $(window).trigger("delayed-resize");
    }, 250);
});
theme.init = function () {
    theme.customerTemplates.init();
    slate.rte.wrapTable();
    slate.rte.iframeReset();
    slate.a11y.pageLinkFocus($(window.location.hash));
    $(".in-page-link").on("click", function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });
    $('a[href="#"]').on("click", function (evt) {
        evt.preventDefault();
    });
};
$(theme.init);
!(function (at) {
    at(document).ready(function () {
        $(".qtyBtn").on("click", function () {
            var qtyField = $(this).parent(".qtyField"),
                oldValue = $(qtyField).find(".qty").val(),
                newVal = 1;
            if ($(this).is(".plus")) {
                newVal = parseInt(oldValue) + 1;
            } else if (oldValue > 1) {
                newVal = parseInt(oldValue) - 1;
            }
            $(qtyField).find(".qty").val(newVal);
        });
    }),
        at(window).resize(function () {});
    at(".btn-filter").click(function () {
        at(".filterbar").toggleClass("active");
    });
    at(".closeFilter").click(function () {
        at(".filterbar").toggleClass("active");
    });
    at(".product-tags li").eq(10).nextAll().hide();
    at(".btnview").click(function () {
        at(".product-tags li").not(".filter--active").show();
        at(this).hide();
    });
    var date = new Date();
    date.setTime(date.getTime() + 20 * 1000);
    if ($("#newsletter-modal").length) {
        var popupTime = at("#newsletter-modal").attr("data-time");
        if (Cookies.get("visited") != "true") {
            setTimeout(function () {
                $(".newsletter-wrap").show();
                $("#newsletter-modal").show();
            }, popupTime);
        } else {
            at("#newsletter-modal").hide();
            at(".newsletter-wrap").hide();
        }
    }
    at(document).mouseup(function (e) {
        var container = at("#newsletter-modal");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.hide();
            $(".newsletter-wrap").fadeOut();
        }
    });
    at(".closepopup").click(function () {
      at("#newsletter-modal").fadeOut();
      at(".newsletter-wrap").fadeOut();
      Cookies.set("visited", "true", { expires: 1 });
    });
    if ($(".notification-bar").length) {
      if (Cookies.get("promotion") != "true") {
        at(".notification-bar").show();
      }
    }
    at(".close-announcement").click(function () {
        at(".notification-bar").slideUp();
        Cookies.set("promotion", "true", { expires: 1 });
    });
    at(".js-mobile-nav-toggle").click(function () {
        //at(".notification-bar").slideUp();
        //Cookies.set("promotion", "true", { expires: 1 });
    });
    at(".site-header__cart").click(function () {
        //at(".notification-bar").slideUp();
        //Cookies.set("promotion", "true", { expires: 1 });
    });
    at(".site-header__cart").click(function () {
        at("body").toggleClass("cart-open");
        at("html").toggleClass("back-fixed");
    });
    at(".popup-modal").click(function () {
        /*at(".notification-bar").slideUp();*/
        Cookies.set("promotion", "true", { expires: 1 });
    });
    at(".user-menu").click(function () {
        if ($(".currencies").is(":visible")) {
            $(".currencies").slideUp();
        }
        at(".customer-links").slideToggle();
    });
    if (theme.fixedHeader) {
        window.onscroll = function () {
            myFunction();
        };
        function myFunction() {
            if (at(window).width() > 992) {
                if ($(window).scrollTop() > 145) {
                    at(".header-wrap").addClass("stickyNav animated fadeInDown");
          			at("html").addClass("stickyhead");
                } else {
                    at(".header-wrap").removeClass("stickyNav fadeInDown");
          			at("html").removeClass("stickyhead");
                }
            } else {
              if ($(window).scrollTop() > 145) {
                  at("html").addClass("stickyhead");
              } else {
                  at("html").removeClass("stickyhead");
              }
            }
        }
    }
    at("#faq .panel-title").click(function () {
        at(this).toggleClass("active");
        at(this).next().slideToggle();
    });
    at("#site-scroll").click(function () {
        at("html, body").animate({ scrollTop: 0 }, 1000);
        return false;
    });
    at(window).scroll(function () {
        if (at(this).scrollTop() > 300) {
            at("#site-scroll").fadeIn();
        } else {
            at("#site-scroll").fadeOut();
        }
    });

  // Remove product from cart drawer
  $(document).on("click", ".remove-cart-item", function(){
    var updateData = { updates: {} };
    var mainId = $(this).data("id");
    var mainTime = $(this).data("time");
    var removeLine = $(this).data('index');

    if(mainTime){
      if($("body").hasClass("template-cart")){
        $(this).parents(".productItems").find("li").each(function(){
          if($(this).find(".remove-cart-item").data("time")){
            if($(this).find(".remove-cart-item").data("time") == mainTime){
              var id = $(this).find(".remove-cart-item").data("id");
              updateData.updates[id] = 0;
            }
          }
        });
      }else{
        $(this).parents(".mini-products-list").find("li.grid").each(function(){
          if($(this).find(".remove-cart-item").data("time")){
            if($(this).find(".remove-cart-item").data("time") == mainTime){
              var id = $(this).find(".remove-cart-item").data("id");
              updateData.updates[id] = 0;
            }
          }
        });
      }
      
      var ajaxData = updateData;
      var url = '/cart/update.js';
    }else{
      var ajaxData = { 'line':removeLine, 'quantity':0 }
      var url = '/cart/change.js';
    }
  
    $.ajax({
      type: 'POST',
      url:url,
      data: ajaxData,
      dataType:'json',
      success: function(updateData){
        getCartDrawer();
        getCart();
      }
    });
  });
  
})(jQuery);

// Get cart drawer HTML
function getCartDrawer(){
  $.ajax({
    type:"GET",
    url:"/collections",
    dataType:'html',
    success:function(data){
      var newHTML = $(data).find("#header-cart").html();
      var newCount = $(data).find(".site-header__cart-count").text();
      $(".site-header__cart-count").text(newCount);
      $("#header-cart").html(newHTML);
    }
  });
}

// Get cart drawer HTML
function getCart(){
  $.ajax({
    type:"GET",
    url:"/cart",
    dataType:'html',
    success:function(data){
      var newHTML = $(data).find(".container[data-section-id='cart-template']").html();
      var newCount = $(data).find(".site-header__cart-count").text();
      $(".site-header__cart-count").text(newCount);
      $(".container[data-section-id='cart-template']").html(newHTML);
    }
  });
}


/* Custom filter */

class CollectionPageFilterNew extends HTMLElement {
  constructor(){
    super();
    this.filterOption = [];
    this.main_form = this.querySelector("form");
    
    this.debounce = (func) => {
      let debounceTimer
      return function() {
        const context = this
        const args = arguments
        clearTimeout(debounceTimer)
        debounceTimer
        = setTimeout(() => func.apply(context, args), 500)
      }
    } 

    //this.main_form.addEventListener("input", this.debounce(this.applyFilter.bind(this)));
    this.main_form.addEventListener('change', (event) => {
      this.querySelector("#flt-loader").classList.contains("active") ? '' : this.querySelector("#flt-loader").classList.add("active");
      if (event.target.type === 'checkbox') {
        this.debounce(this.applyFilter.bind(this))(event);
      } else if(event.target.type === 'range'){
        this.debounce(this.applyFilter.bind(this))(event);
      }
    });
  }

  applyFilter(event){
    const form_data = new FormData(this.main_form);
    const search_para = new URLSearchParams(form_data).toString();
    const cleanParameter = this.removeDuplicateQueryParams(search_para);
    this.getPage(cleanParameter, event);
  }

  removeDuplicateQueryParams(queryString) {
    var myArray = queryString.split('&');
    let unique = [...new Set(myArray)];
    const cleanedQueryString = Object.keys(unique).map(key => `${unique[key]}`).join('&');
    return cleanedQueryString;
  }
  
  getPage(searchParam, event){
    const sections = this.getSection();
    sections.map((section)=>{ 
      const url= window.location.pathname+"?section_id="+section.section+"&"+searchParam;
      const filterDataUrl = element => element.url === url;
      this.filterOption.some(filterDataUrl)? this.renderFromArray(filterDataUrl, section, event):this.renderFromUrl(url, section, event);
      this.updateUrl(searchParam);
    });
  }

  renderFromUrl(url, section, event){
    fetch(url)
    .then((response_data)=> { return response_data.text() })
    .then((response) => {
      const response_html = response;
      this.filterOption = [...this.filterOption, {response_html, url}];
      
      if(this.main_form.dataset.filter == 'true'){
       this.renderFilter(response_html,event);
      }
      this.renderProductList(response_html);
    });
  }

  renderFromArray(filterDataUrl, section, event){
    const html = this.filterOption.find(filterDataUrl).response_html;
    if(this.main_form.dataset.filter == 'true'){
      this.renderFilter(html,event);
    }
    this.renderProductList(html);
  }

  renderFilter(response_html,event){
    const html_data = new DOMParser().parseFromString(response_html, 'text/html');
    const newFilterData = html_data.querySelector(".flt-navigation");
    if(document.querySelector(".flt-navigation") && html_data.querySelector(".flt-navigation")){
      document.querySelector(".flt-navigation").innerHTML = html_data.querySelector(".flt-navigation").innerHTML;
    }
  }

  renderProductList(response_html) {
    const html_data = new DOMParser().parseFromString(response_html, 'text/html');
    const select = document.querySelector(".collection_matrix");
    if(select && html_data.querySelector(".collection_matrix")){
      select.innerHTML = html_data.querySelector(".collection_matrix").innerHTML;
    }
    //setTimeout(() => {
      this.querySelector("#flt-loader").classList.contains("active") ? this.querySelector("#flt-loader").classList.remove("active") : '';
    //}, 500);
  }

  onActiveFilterClick(event) {
    this.getPage(new URL(event.currentTarget.href).searchParams.toString());
  }
  
  closeFilterDrawer(){
    this.querySelector(".flt-navigation").classList.contains("active") ? this.querySelector(".flt-navigation").classList.remove("active") : '';
    this.querySelector(".collection-filter-form #flt-overlay").classList.contains("active") ? this.querySelector(".collection-filter-form #flt-overlay").classList.remove("active") : '';
    document.documentElement.classList.contains("filter-pop-opnd") ? document.documentElement.classList.remove("filter-pop-opnd") : '';
  }

  getSection(){
    return [
      {
        class:'colle-temp',
        section:document.querySelector(".colle-temp").dataset.sectionId
      }
    ]
  }

  updateUrl(searchParam){
    history.pushState({}, '', `${window.location.pathname}${searchParam && '?'.concat(searchParam)}`);
  }
}
customElements.define('colle-filter', CollectionPageFilterNew);

class viewFilteredProducts extends HTMLElement {
  constructor(){
    super();
    this.querySelector("button.view-product-btn").addEventListener("click", (event) => {
      const filterForm = this.closest('colle-filter') || document.querySelector('colle-filter');
      filterForm.closeFilterDrawer(event);
    });
    this.querySelector("button.clear-all-btn").addEventListener("click", (event) => {
      const filterForm = this.closest('colle-filter') || document.querySelector('colle-filter');
      filterForm.querySelector("#flt-loader").classList.contains("active") ? '' : filterForm.querySelector("#flt-loader").classList.add("active");
      setTimeout(() => {
        filterForm.getPage('', event);
      }, 800);
    });
  }
}
customElements.define('view-product', viewFilteredProducts);

// price code change
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.range-slider-in input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
  }

  adjustToValidValues(input) {
    const isRange = (input.type == "range");
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;

    // Ruler
    const rangeInputs = this.querySelectorAll('.range-slider-in input');
    const numberInputs = this.querySelectorAll('.flt-range-inputs input');
    const minRangeInput = rangeInputs[0];
    const maxRangeInput = rangeInputs[1];
    const minNumberInput = numberInputs[0];
    const maxNumberInput = numberInputs[1];
    let minPrice = isRange ? rangeInputs[0].value : numberInputs[0].value;
    let maxPrice = isRange ? rangeInputs[1].value : numberInputs[1].value;

    if (Number(minPrice) > Number(maxPrice)) {
      let tempValue = maxPrice;
      maxPrice = minPrice;
      minPrice = tempValue;
      minRangeInput.value= minPrice;
      minNumberInput.value= minPrice;
      maxRangeInput.value = maxPrice;
      maxNumberInput.value = maxPrice;
    }else{
      if(input.classList.contains("rulerinput-min")){
        document.querySelector(".range-slider-in .range-min-price").innerHTML = theme.Currency.formatMoney(minPrice+'.00', theme.moneyFormat)/*theme.Currency.formatMoney(input.value, theme.moneyFormat)*/;
        isRange ? minNumberInput.value = minPrice : minRangeInput.value= minPrice;
      }
      if(input.classList.contains("rulerinput-max")) {
        document.querySelector(".range-slider-in .range-max-price").innerHTML = theme.Currency.formatMoney(maxPrice+'.00', theme.moneyFormat)/*theme.Currency.formatMoney(input.value, theme.moneyFormat)*/;
        isRange ? maxNumberInput.value = maxPrice : maxRangeInput.value= maxPrice;
      }
    }
  }
}

customElements.define('price-range', PriceRange);

/* Open filter drawer */
if(document.querySelector("#Collection")){
  if(document.querySelector("#Collection").querySelector(".Filter-btn")){
    document.querySelector("#Collection").querySelector(".Filter-btn").addEventListener("click", function(){
      if(document.querySelector(".flt-navigation")){
        document.querySelector(".flt-navigation").classList.toggle("active")
        document.querySelector("#flt-overlay").classList.toggle("active")
      }
    });
  }
}

/* Close filter on overlay click */
if(document.querySelector("#flt-overlay")){
  document.querySelector("#flt-overlay").addEventListener("click", function(){
    if(document.querySelector(".flt-navigation")){
      document.querySelector(".flt-navigation").classList.contains("active") ? document.querySelector(".flt-navigation").classList.remove("active") : '';
      this.classList.contains("active") ? this.classList.remove("active") : '';
      document.documentElement.classList.contains("filter-pop-opnd") ? document.documentElement.classList.remove("filter-pop-opnd") : '';
    }
  });
}